import React from 'react';

const ThemeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M12 3a9 9 0 110 18 9 9 0 010-18zm0 2v14a7 7 0 100-14z" />
  </svg>
);

export default ThemeIcon;
